import React, { FunctionComponent } from "react";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import Banner from "../../components/banner";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";
import SooksessStories from "components/sookStories";
import TitleText from "components/titleText";

interface ThankYouPageProps {}
export const ThankYou: FunctionComponent<ThankYouPageProps> = () => {
  return (
    <DefaultLayout>
      <Banner />
      <TitleText code="titleText" />
      <BookingEnquiryForm />
      <SooksessStories hasThumbs={true} variant="three-slides" />
    </DefaultLayout>
  );
};

export default ThankYou;
